{
  "#LOGIN": {
    "TITLE": "Anmeldung",
    "USERNAME": "Benutzername",
    "PASSWORD": "Passwort",
    "REMEMBER": "Eingeloggt bleiben (nicht auf öffentlichen Geräten verwenden!)",
    "LOGIN": "Anmelden",
    "SCAN": "Scannen",
    "MESSAGES": {
      "FAILED": {
        "SUBJECT": "Login Fehlgeschlagen",
        "UNAUTHORIZED": "Benutzername und/oder Passwort sind inkorrekt",
        "NO_CONNECTION": "Es konnte keine Verbindung zum Server hergestellt werden. Bitte überprüfen Sie Ihre Internetverbindung oder versuchen Sie es später nochmal.",
        "UNKNOWN": "Ein unerwarteter Fehler ist aufgetreten!"
      },
      "EXPIRED": "Sie wurden aufgrund von Inaktivität automatisch abgemeldet",
      "LOGOUT": "Sie wurden erfolgreich abgemeldet",
      "AUTHENTICATED": "Sie wurden erfolgreich angemeldet",
      "AUTHENTICATING": "Sie werden angemeldet..."
    },
    "SETTINGS": "Einstellungen",
    "BACK": "<< Zurück zum Login"
  },
  "#FORGOT_PASSWORD": {
    "TITLE": "Passwort vergessen",
    "EMAIL": "E-Mail",
    "SUBMIT": "Wiederherstellungslink anfordern",
    "BACK": "Zurück zum Login"
  },
  "#LOGOUT": {
    "TITLE": "Abmelden"
  }
}
